import { StateCreator } from 'zustand';
import { DealerState } from '../types/stateTypes';
import { UserState } from '../../auth/userSlice';
import { debugLog } from '@/utils/debugLogger';

type SetState = Parameters<StateCreator<DealerState & UserState>>[0];
type GetState = Parameters<StateCreator<DealerState & UserState>>[1];

/**
 * Initialize dealer store with SSR data from window.__HOME_PAGE_DATA__
 */
export const initializeDealersFromSSR = (set: SetState, get: GetState, selectedMetal: 'gold' | 'silver' = 'gold') => {
  if (typeof window === 'undefined') return;
  
  const homePageData = (window as any).__HOME_PAGE_DATA__;
  
  if (!homePageData?.recommendedDealers) {
    debugLog('dealer', '[SSR] No dealer SSR data found, skipping initialization', undefined, 'initializeDealersFromSSR');
    return;
  }
  
  const dealers = homePageData.recommendedDealers[selectedMetal] || [];
  
  debugLog('dealer', '[SSR] Initializing dealers with SSR data', { 
    selectedMetal,
    dealerCount: dealers.length 
  }, 'initializeDealersFromSSR');
  
  // Transform dealers to match the expected format
  const transformedDealers = dealers.map((dealer: any) => ({
    ...dealer,
    isFavorite: dealer.isFavorite || false,
    // Ensure all expected fields are present
    rating: dealer.rating || 0,
    buySpread: dealer.buySpread || 0,
    spreadType: dealer.spreadType || 'PERCENTAGE'
  }));
  
  set({ dealers: transformedDealers });
};